// ** Redux
import { createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ############################################################

export const getUserEmail = createAsyncThunk(
	"globalUser/getUserEmail",
	createApiCall(async (_, client) => {
		const response = await client.get("/user/email");
		return response.data;
	})
);

// ############################################################
